module.exports = __webpack_public_path__ + "img/lk.152f9e10.png";